<template>
  <div class="menu-actions-container">
    <BaseButton
      variant="primary"
      color="green-6"
      icon="edit-02"
      @click="$emit('edit')"
      class="menu-action-button"
      size="md"
      v-if="!canOnlyDelete"
      ><span class="bold">{{ $t("menu_settings.edit") }}</span></BaseButton>
    <BaseButton
      @click="$emit('duplicate')"
      icon="copy"
      size="md"
      variant="secondary"
      class="menu-action-button"
      color="blue-6"

      v-if="!canOnlyDelete || allowDuplicate"
      >{{ $t("menu_settings.duplicate") }}</BaseButton
    >
    <BaseButton
      @click="$emit('delete')"
      icon="trash"
      variant="secondary"
      size="md"
      class="menu-action-button"
      color="red-4"
      >{{ $t("menu_settings.delete") }}</BaseButton
    >
  </div>
</template>
<script>
export default {
  props: {
    renaming: Boolean,
    canOnlyDelete: Boolean,
    allowDuplicate: Boolean
  }
};
</script>
<style scoped>
.menu-actions-container {
  width: 100%;
  display: contents;
}

.menu-action-button {
  width: 250px;
  min-width: 250px;
}
</style>
